import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-society',
  templateUrl: './society.component.html',
  styleUrls: ['./society.component.scss']
})
export class SocietyComponent implements OnInit {
  societyForm: FormGroup;
  isLoading: boolean;
  districtList: any;
  TalukaList: any;
  cityList:any;
  initialValue = '';
  keyword: any = 'Area';
  keyword1 = 'Area'
  areas: any;
  VillageList: any;
  submitted: boolean = false;
  notfoundshow: boolean;
  stateId: any;
  fieldsData: any;
  URL: string;

  constructor(private fb: FormBuilder, 
    private gs: GeneralService, 
    public dialogRef: MatDialogRef<SocietyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.stateId = this.data.stateID;
    this.fieldsData = this.data.fieldsData;
    this.societyForm = this.fb.group({
      autocompleteField: new FormControl('',Validators.required),
      societyname: new FormControl('', Validators.required),
      districtid: new FormControl(null),
      talukaid: new FormControl(null),
      citysurveyofficeid: new FormControl(null),
      taluka: new FormControl(null),
      villageid: new FormControl(null),
      wardid: new FormControl(null),
      // CityID:new FormControl(null)
    });
    // this.getCityList();
  }
  selectEvent(item) {
    this.notfoundshow = false;
    console.log(item);
    if(item.DistrictId) {
      this.societyForm.controls.districtid.setValue(item.DistrictId);
    }
    if(item.TalukaId) {
      this.societyForm.controls.talukaid.setValue(item.TalukaId);
    }
    if(item.CitySurveyOfficeID) {
      this.societyForm.controls.citysurveyofficeid.setValue(item.CitySurveyOfficeID);
    }
    if(item.VillageId) {
      this.societyForm.controls.villageid.setValue(item.VillageId);
    }
    if(item.WardID) {
      console.log('adsdg');
      this.societyForm.controls.wardid.setValue(item.WardID);
    }
  }
  // getCityList(){
  //   this.fieldsData.forEach((element)=>{
  //     if(element.DBColumnName == 'CityID' && element.FieldType == 'Dropdown'){
  //       this.URL = element.APIName;
  //       this.isLoading = true;
  //       this.gs.dynamicData(this.URL).pipe(first()).subscribe((data) => {
  //         this.URL = '';
  //         this.isLoading = false;
  //         if (data.error) {
  //           Swal.fire({
  //             title: data.error_code,
  //             text: data.message,
  //             type: 'error',
  //           });
  //           return;
  //         } else {
  //           this.cityList = data.data;
  //         }
  //       });
  //     }
  //   })
  // }
  onChangeSearch(search: string) {
    this.societyForm.controls.villageid.setValue(null);
    this.societyForm.controls.talukaid.setValue(null);
    if (search !== undefined && search.length >= 1) {
      this.gs.areabystateid1(this.stateId, search)
        .pipe(first())
        .subscribe(
          data => {
            if (data.error) {
              return;
            } else {
              this.areas = data.data;
              this.notfoundshow = true;
            }
          });
    } else if (search !== undefined && search.length === 0) {
      this.areas = null;
      this.notfoundshow = false;
    }
  }
  onclear() {
    this.societyForm.controls.villageid.setValue(null);
    this.societyForm.controls.talukaid.setValue(null);
  }
  get f() { return this.societyForm.controls; }
  onChangeSearchvillage(search: string, apiurl: any) {
    if (search !== undefined && search.length >= 1) {
      this.gs.areabystateid(apiurl, search)
        .pipe(first())
        .subscribe(
          data => {
            if (data.error) {
              return;
            } else {
              this.areas = data.data;
              this.notfoundshow = true;
            }
          });
    } else if (search !== undefined && search.length === 0) {
      this.areas = null;
      this.notfoundshow = false;
    }
  }

  onSubmit() {
    this.submitted = true;
    this.societyForm.controls.societyname.setValue(this.societyForm.controls.societyname.value.trim());
    // if(this.societyForm.controls.CityID.valid){
    //     this.societyForm.controls.villageid.clearValidators();
    //     this.societyForm.controls.wardid.clearValidators();
    //     this.societyForm.controls.autocompleteField.clearValidators();
        // this.societyForm.controls.villageid.clearValidators();
      // }
      if( !this.societyForm.controls.societyname.valid || (! this.societyForm.controls.wardid.valid && ! this.societyForm.controls.villageid.valid)) {
          return;
        }
        this.societyForm.removeControl('taluka');
        // this.societyForm.controls.societyname.setValue(this.societyForm.controls.societyname.value.trim())
        console.log('Society Form',this.societyForm.value)
      if(this.societyForm.valid){
        this.isLoading = true;
        this.gs.addSociety(this.societyForm.value)
        .subscribe((res) => {
          if(res.status == 200){
            Swal.fire({
              position: 'top-end',
              type: 'success',
              title: 'Society Added SuccessFully',
              showConfirmButton: false,
              timer: 1500          
            });
            this.isLoading = false;
            this.onConfirmClick(true);
          }
           else {
            Swal.fire({
              title: "Can't Add Society",
              text: 'Society cannot be added; duplicate record found.',
              type: "info",
            });
            this.isLoading = false;
            this.onConfirmClick();
          }
        },(error) => {                             
          this.isLoading = false;
          Swal.fire({
            title: error.status,
            text: error.message,
            type: "error",
          });
          this.onConfirmClick();
         }
        );
      }else{
        this.isLoading= false;
       return
      }
      
    }

  onConfirmClick(result?): void {
    if(result){
      this.dialogRef.close(true);
    }
    else{
      this.dialogRef.close();
    }
  }

}
